import React from 'react'
import { WebTooltip } from '../../../../../../Project/UI/WebTooltip'

export function SliderColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
  setPage,
  hideTooltip,
  themeKey,
  elementClasses,
}) {
  // Calculate the min and max
  // using the preFilteredRows

  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    preFilteredRows.forEach((row) => {
      min = Math.min(row.values[id], min)
      max = Math.max(row.values[id], max)
    })
    return [min, max]
  }, [id, preFilteredRows])

  return (
    <>
      <WebTooltip
        title={filterValue || min}
        {...(hideTooltip ? { open: false } : {})}
        classes={{ tooltip: `ft--theme--${themeKey}--tooltip ${elementClasses}--tooltip` }}>
        <input
          type="range"
          min={min}
          max={max}
          value={filterValue || min}
          onChange={(e) => {
            setFilter(parseInt(e.target.value, 10))
            if (e.target.value) {
              setPage(0)
            }
          }}
        />
      </WebTooltip>
      <button onClick={() => setFilter(undefined)}>Off</button>
    </>
  )
}
